import React, { useState, useEffect, useRef } from 'react';
import defaultStyles from './Dropdown.module.css';
import { ChevronDown } from 'lucide-react';

const Dropdown = ({ options, placeholder, onSelect, styles = defaultStyles }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelect = (option) => {
        onSelect(option.value);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    return (
        <div className={styles.dropdown} ref={dropdownRef}>
            <button
                className={styles.dropdownToggle}
                onClick={() => setIsOpen(!isOpen)}
            >
                {placeholder}
                <ChevronDown className={[styles.dropdownChevron, isOpen ? styles.dropdownChevronOpen : ''].filter(Boolean).join(' ')} />
            </button>
            {isOpen && (
                <ul className={styles.dropdownMenu}>
                    {/* Add a dummy option to ensure the dropdown menu renders something */}
                    {options.length === 0 && (
                        <li className={styles.dropdownItem}>No options available</li>
                    )}
                    {options.map((option) => (
                        <li
                            key={option.value}
                            className={styles.dropdownItem}
                            onClick={() => handleSelect(option)}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default Dropdown;
